type VirtualAccountInstruction = {
    title: string;
    steps: string[];
};

export const VA_INSTRUCTIONS: Record<string, VirtualAccountInstruction[]> = {
    BNI: [
        {
            title: "Internet Banking",
            steps: [
                "Akses ibank.bni.co.id.",
                "Masukkan User ID dan password.",
                "Klik menu Transfer, lalu pilih Virtual Account Billing.",
                'Kemudian, masukkan nomor Virtual Account Anda (Contoh "12345XXXXXXXXXXX") yang akan dibayar.',
                "Lalu pilih rekening debit yang akan digunakan. Kemudian tekan Lanjutkan.",
                "Tagihan yang akan dibayar akan muncul di layar konfirmasi.",
                "Masukkan Kode Autentikasi Token.",
                "Anda akan menerima notifikasi bahwa transaksi berhasil.",
            ],
        },
        {
            title: "BNI Mobile Banking",
            steps: [
                "Akses BNI Mobile Banking melalui smartphone.",
                "Masukkan User ID dan password.",
                "Klik menu Transfer, lalu pilih Virtual Account Billing.",
                "Pilih menu Virtual Account Billing, lalu pilih rekening debit.",
                'Masukkan nomor Virtual Account Anda (Contoh "12345XXXXXXXXXX") di menu Input Baru.',
                "Tagihan yang akan dibayar akan muncul di layar konfirmasi.",
                "Konfirmasi transaksi dan masukkan Password Transaksi.",
                "Pembayaran Anda Berhasil.",
            ],
        },
        {
            title: "BNI ATM",
            steps: [
                "Masukkan Kartu Anda.",
                "Pilih bahasa.",
                "Masukkan PIN ATM.",
                "Kemudian, pilih Lainnya.",
                'Pilih Transfer dan pilih jenis rekening yang akan Anda gunakan (Contoh "Dari Rekening Tabungan").',
                'Pilih Virtual Account Billing. Masukkan nomor Virtual Account 16 Digit Anda (Contoh "12345XXXXXXXXXX").',
                "Tagihan yang akan dibayar akan muncul di layar konfirmasi.",
                "Konfirmasi, jika sudah benar, lanjutkan transaksi.",
                "Transaksi Anda telah selesai.",
            ],
        },
    ],
    "BRI": [
        {
            title: "Internet Banking",
            steps: [
                "Login ke internet banking Bank BRI Anda.",
                "Pilih menu Pembayaran lalu klik menu BRIVA.",
                "Pilih rekening sumber dan masukkan Kode Bayar lalu klik Kirim.",
                "Detail transaksi akan ditampilkan, pastikan data sudah sesuai.",
                "Klik Lanjutkan.",
                "Masukkan kata sandi ibanking lalu klik Request untuk mengirim m-PIN ke nomor HP Anda.",
                "Periksa HP Anda dan masukkan m-PIN yang diterima lalu klik Kirim.",
                "Transaksi sukses, simpan bukti transaksi Anda.",
            ],
        },
        {
            title: "Aplikasi BRImo",
            steps: [
                "Login ke aplikasi BRImo Anda.",
                "Pilih menu BRIVA.",
                "Pilih sumber dana dan masukkan Nomor Pembayaran lalu klik Lanjut.",
                "Klik Lanjut.",
                "Detail transaksi akan ditampilkan, pastikan data sudah sesuai.",
                "Klik Lanjutkan.",
                "Klik Konfirmasi.",
                "Klik Lanjut.",
                "Masukkan kata sandi ibanking Anda.",
                "Klik Lanjut.",
                "Transaksi sukses, simpan bukti transaksi Anda.",
            ],
        },
        {
            title: "ATM BRI",
            steps: [
                "Lakukan pembayaran melalui ATM Bank BRI.",
                "Pilih menu Transaksi Lain > Pembayaran > Lainnya > Pilih BRIVA.",
                "Masukkan Nomor VA.",
                "Pilih Ya untuk memproses pembayaran.",
            ],
        },
        {
            title: "Agen BRI LINK",
            steps: [
                "Datangi agen BRILink terdekat.",
                "Berikan nomor BRIVA.",
                "Bayarkan uang tunai senilai sesuai nominal.",
                "Simpan bukti transaksi sebagai bukti pembayaran yang sah.",
            ],
        },
    ],
    CIMB: [
        {
            title: "Internet Banking Bank Lain",
            steps: [
                "Login ke internet banking.",
                "Pilih menu transfer ke bank lain.",
                'Pilih bank tujuan Bank CIMB Niaga (kode bank "022").',
                "Masukkan nomor virtual account.",
                "Masukkan jumlah pembayaran sesuai tagihan.",
                "Nomor, nama virtual account dan jumlah tagihan ditampilkan di layar.",
                "Ikuti instruksi untuk menyelesaikan transaksi.",
                "Konfirmasi pembayaran ditampilkan di layar.",
            ],
        },
        {
            title: "CIMB Clicks",
            steps: [
                "Login ke CIMB Clicks.",
                "Pilih menu Bayar Tagihan / Pay Bills.",
                "Pilih Rekening Sumber dan Tipe Pembayaran > Virtual Account.",
                "Masukkan nomor virtual account.",
                "Nomor, nama virtual account dan jumlah tagihan ditampilkan di layar.",
                "Masukkan 6 digit mPIN dan tekan tombol Submit.",
                "Konfirmasi pembayaran ditampilkan di layar.",
            ],
        },
        {
            title: "CIMB ATM",
            steps: [
                "Masukkan Kartu ATM dan PIN CIMB.",
                "Pilih menu Pembayaran > Lanjut > Virtual Account.",
                "Masukkan nomor virtual account.",
                "Pilih rekening debit.",
                "Nomor, nama virtual account dan jumlah tagihan ditampilkan di layar.",
                "Pilih OK untuk melakukan pembayaran.",
                "Konfirmasi pembayaran ditampilkan di layar.",
            ],
        },
    ],
    PERMATA: [
        {
            title: "Internet Banking Permata",
            steps: [
                "Login ke iBanking Permata, pilih Transfer.",
                "Pilih antara rekening PermataBank.",
                "Masukkan Rekening Sumber & nomor Virtual Account.",
                "Masukkan kode SMS/Token & transaksi selesai.",
            ],
        },
        {
            title: "Permata Mobile Banking",
            steps: [
                "Buka aplikasi permata, pilih Transfer.",
                "Pilih menu Antar Rekening PermataBank.",
                "Masukkan Rekening Sumber & nomor Virtual Account.",
                "Masukkan kode SMS/Token & transaksi selesai.",
            ],
        },
        {
            title: "Permata Bank ATM",
            steps: [
                "Pilih Transfer, lalu Transfer antar Rekening PermataBank.",
                "Masukkan nomor Virtual Account.",
                "Pilih Rekening untuk Debit.",
                "Konfirmasi dan selesaikan pembayaran.",
            ],
        },
    ],
    "BCA": [
        {
            title: "Internet Banking",
            steps: [
                "Login ke internet banking Bank BCA Anda.",
                "Pilih menu Pembayaran lalu klik menu BCA Virtual Account.",
                "Pilih rekening sumber dan masukkan Kode Bayar lalu klik Kirim.",
                "Detail transaksi akan ditampilkan, pastikan data sudah sesuai.",
                "Klik Lanjutkan.",
                "Masukkan kata sandi ibanking lalu klik Request untuk mengirim m-PIN ke nomor HP Anda.",
                "Periksa HP Anda dan masukkan m-PIN yang diterima lalu klik Kirim.",
                "Transaksi sukses, simpan bukti transaksi Anda.",
            ],
        },
        {
            title: "Aplikasi m-BCA",
            steps: [
                "Login ke aplikasi BCA Mobile.",
                "Pilih menu m-Transfer.",
                "Pilih menu BCA Virtual Account.",
                "Masukan nomor BCA Virtual Account lalu klik Send.",
                "Cek nominal yang muncul.",
                "Masukan PIN m-BCA.",
                "Notifikasi transaksi berhasil akan muncul.",
            ],
        },
        {
            title: "ATM BCA",
            steps: [
                "Lakukan pembayaran melalui ATM Bank BCA.",
                "Pilih menu Penarikan Tunai / Transaksi Lainnya > Transaksi Lainnya > Transfer > Pilih Menu Ke Rek BCA Virtual Account.",
                "Masukkan Nomor VA dan klik benar.",
                "Check Detail Transaksi dan pilih Ya.",
                "Transaksi Selesai.",
            ],
        },
    ],
    MANDIRI: [
        {
            title: "Mandiri Online",
            steps: [
                "Buka aplikasi Mandiri online di smartphone atau PC Anda.",
                "Masukkan user id dan pin di halaman login.",
                "Pilih menu BAYAR, BUAT PEMBAYARAN BARU.",
                "Pilih menu LAINNYA MULTI PEMBAYARAN.",
                "Pilih Rekening Sumber.",
                "Masukkan Nomor Virtual.",
                "Tekan Berikutnya.",
                "Tekan KONFIRMASI.",
                "Masukkan MPIN Banking lalu tekan OK.",
                "Transaksi Selesai.",
            ],
        },
        {
            title: "Mandiri Mobile Banking",
            steps: [
                "Buka Website/buka aplikasi Mobile Banking.",
                "Masukkan User dan Password.",
                "Pilih menu Transfer.",
                "Pilih menu Transfer Online Antar Bank.",
                'Pilih kode/Nama Bank "008/Bank Mandiri".',
                "Masukkan nomor rekening penerima berupa VA NUMBER (12345XXXXXXXXXX).",
                "Masukkan jumlah nominal pembayaran.",
                "Konfirmasi.",
                "Transaksi berhasil, bukti pembayaran dapat diunduh.",
            ],
        },
        {
            title: "Mandiri ATM",
            steps: [
                "Masukkan kartu ATM dan PIN.",
                "Pilih menu BAYAR/BELI.",
                "Pilih menu LAINNYA MULTI PEMBAYARAN.",
                'Masukkan kode Perusahaan/Institusi, yaitu "89795" (MC PAYMENT).',
                'Masukkan VA NUMBER Contoh "12345XXXXXXXXXX".',
                "KONFIRMASI, Tekan 1 lalu tekan OK.",
                "Transaksi Selesai.",
                "Simpan Bukti Pembayaran.",
            ],
        },
    ],
    BNC: [
        {
            title: "BNC Digital Bank",
            steps: [
                "Login ke aplikasi bank digital BNC.",
                'Pilih "neobank HematPay".',
                "Masukkan Nomor Virtual Account 12345XXXXXXXXXXXX.",
                "Periksa kembali total jumlah pembayaran.",
                'Klik "confirm payment" jika jumlahnya sesuai.',
                "Masukkan nomor PIN.",
                "Transaksi berhasil.",
            ],
        },
        {
            title: "Internet Banking of Other Bank",
            steps: [
                "Login ke internet banking.",
                "Pilih menu transfer ke bank lain.",
                'Pilih bank tujuan Bank Neo Commerce (kode bank "490").',
                "Masukkan nomor virtual account.",
                "Masukkan jumlah pembayaran sesuai tagihan.",
                "Nomor, nama virtual account dan jumlah tagihan ditampilkan di layar.",
                "Ikuti instruksi untuk menyelesaikan transaksi.",
            ],
        },
    ],
    FINPAY: [
        {
            title: "Internet Banking atau Mobile Banking",
            steps: [
                "Login ke aplikasi internet banking atau mobile banking Anda.",
                'Pilih menu "Pembayaran" atau "Transfer", kemudian cari menu seperti "Virtual Account", "Virtual Account Billing", atau "Multipayment".',
                'Pilih "Finpay" atau "Finnet Indonesia, PT" sebagai penyedia jasa.',
                'Masukkan Nomor Virtual Account dan Nominal yang akan dibayar, lalu klik "Lanjut".',
                "Konfirmasi pembayaran Anda, lalu masukkan PIN atau challenge code token untuk menyelesaikan transaksi.",
            ],
        },
        {
            title: "Gerai Retail (Indomaret/Alfamart)",
            steps: [
                "Catat kode pembayaran Finpay yang Anda terima dari website atau aplikasi tempat Anda bertransaksi.",
                "Kunjungi gerai Indomaret atau Alfamart terdekat.",
                "Sampaikan kepada kasir bahwa Anda ingin membayar Finpay dan berikan kode pembayaran Anda.",
                "Kasir akan memproses pembayaran. Pastikan nominal yang tertera sesuai, lalu lakukan pembayaran.",
                "Mintalah bukti pembayaran transaksi Finpay Anda dari kasir.",
            ],
        },
    ],
};
